import { observable, action, toJS } from 'mobx';
import {
  updateTeam,
} from '@/pages/business/server/team';
import {
  getTeamMember,
  getTeamRole,
  updateTeamMember,
  deleteTeamMember,
  addTeamMember,
} from '@/pages/home/server/teamServer';
import {
  UpdateTeam,
} from '@/pages/business/types';
import {
  UpdateTeamMember,
  DeleteTeamMember,
  AddTeamMember,
  TeamRoleData,
  TeamMemberData,
} from '@/pages/home/type/teamType';
import errCode from '@/utils/request/errCode';
import Message from '@/component/Message';
import i18next from 'i18next';
import { get } from 'lodash';
import dayjs from 'dayjs';

class TeamStore {
  @observable currentNav = 1;

  @observable teamMemberList: TeamMemberData[] = [];

  @observable teamRole: TeamRoleData[] = [];

  @observable teamMemberPage = {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPage: 0,
  };

  @action
  // eslint-disable-next-line class-methods-use-this
  async updateTeam(data: UpdateTeam) {
    const result = await updateTeam(data);
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('update_team_error'));
      return;
    }
    Message.success(i18next.t('update_team_success'));
  }

  @action
  async getTeamMember(data: { teamId: string}) {
    const result = await getTeamMember({
      ...data,
      page: this.teamMemberPage.page,
      pageSize: this.teamMemberPage.pageSize,
    });
    this.teamMemberList = get(result, 'data.memberList', []);
    const pageInfo = get(result, 'data.pageInfo', {
      page: 1, pageSize: 20, totalNumber: 0, totalPage: 0,
    });
    this.teamMemberPage = {
      page: pageInfo.page,
      pageSize: pageInfo.pageSize,
      total: pageInfo.totalNumber,
      totalPage: pageInfo.totalPage,
    };
    return Promise.resolve('success');
  }

  @action
  async addTeamMember(data: AddTeamMember) {
    const { teamId } = data;
    const result = await addTeamMember(data);
    if (result.code === 40000) {
      Message.error(i18next.t('add_member_exit'));
      return Promise.resolve('error');
    }
    if (result.code === 40213) {
      Message.error(i18next.t('super_admin_exit'));
      return Promise.resolve('error');
    }
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('add_member_error'));
      return Promise.resolve('error');
    }
    this.teamMemberPage.page = 1;
    this.getTeamMember({ teamId });
    Message.success(i18next.t('add_member_success'));
    return Promise.resolve('success');
  }

  @action
  async getTeamRole() {
    const result = await getTeamRole();
    this.teamRole = get(result, 'data.list');
  }

  @action
  async deleteTeamMember(data: DeleteTeamMember) {
    const { email } = data;
    const result = await deleteTeamMember(data);
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('delete_member_error'));
      return;
    }
    const idx = this.teamMemberList.findIndex((item) => item.staffEmail === email);
    this.teamMemberList.splice(idx, 1);
    this.teamMemberList = toJS(this.teamMemberList);
    Message.success(i18next.t('delete_member_success'));
  }

  @action
  async updateTeamMember(data: UpdateTeamMember) {
    const { roleId, email } = data;
    const result = await updateTeamMember(data);

    if (result.code === 40213) {
      Message.error(i18next.t('super_admin_exit'));
      return Promise.resolve('error');
    }

    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('update_member_error'));
      return Promise.resolve('error');
    }

    const idx = this.teamMemberList.findIndex((item) => item.staffEmail === email);
    const role = this.teamRole.find((item) => item.id === roleId) as TeamRoleData;
    this.teamMemberList.splice(idx, 1, {
      ...this.teamMemberList[idx],
      roleId: role?.id,
      roleName: role?.name,
      createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.teamMemberList = toJS(this.teamMemberList);
    Message.success(i18next.t('update_member_success'));
    return Promise.resolve('success');
  }
}
export default { name: 'teamStore', Store: TeamStore };
